import { render } from "./active-projects.vue?vue&type=template&id=5b0e8564"
import script from "./active-projects.vue?vue&type=script&lang=js"
export * from "./active-projects.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__